'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Layout(props) {
  var classes = 'layout';

  return _react2.default.createElement(
    'main',
    { className: classes },
    props.children
  );
}

Layout.propTypes = {
  children: _propTypes2.default.node
};

exports.default = Layout;